/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export enum CostFeatureFlags {
    cost_2601_f_budget_trend_widget = 'cost_2601_f_budget_trend_widget',
    cost_2601_b_flush_balance_verification = 'cost_2601_b_flush_balance_verification',
    cost_2504_b_trend_observability = 'cost_2504_b_trend_observability',
    cost_2602_f_cost_trend_hide_variance = 'cost_2602_f_cost_trend_hide_variance',
    cost_2602_a_billing_inventory_resource_tags = 'cost_2602_a_billing_inventory_resource_tags',
    cost_2602_f_oci_compartment_based_cost_121002 = 'cost_2602_f_oci_compartment_based_cost_121002',
    cost_2602_b_dimension_grouping_rule_conflict_resolution_119664 = 'cost_2602_b_dimension_grouping_rule_conflict_resolution_119664',
    cost_2602_f_summary_cloud_plus_k8_cost_spend_widget = 'cost_2602_f_summary_cloud_plus_k8_cost_spend_widget',
    cost_2602_b_savings_plans_external_api = 'cost_2602_b_savings_plans_external_api',
    cost_2603_a_allow_cost_usage_api_more_than_31_days = 'cost_2603_a_allow_cost_usage_api_more_than_31_days',
    cost_2604_a_finops_for_ai = 'cost_2604_a_finops_for_ai',
    cost_2604_a_finops_for_ai_anthropic = 'cost_2604_a_finops_for_ai_anthropic',
    cost_2606_a_finops_for_ai_azure = 'cost_2606_a_finops_for_ai_azure',
    cost_2606_f_variance_pct_sort = 'cost_2606_f_variance_pct_sort'
}
